import { shape, string, bool } from 'prop-types';

import GenericStore from '../../classes/generic-store';
import { UserApi } from '../../api/user-api';

const readUser = () => {
  const res = UserApi.readUser();
  return res.hasResolved() ? res.refetch() : res.toPromise();
};

class UserStoreClass extends GenericStore {
  load() {
    return this.setState(
      readUser().then(user => {
        return user.data;
      })
    );
  }

  selectData(state) {
    return this.select(state)?.data || null;
  }

  getDataShape() {
    return shape({
      id: string,
      firstName: string,
      lastName: string,
      email: string,
      organizationId: string,
      candidateId: string,
      role: string,
      fullName: string,
      isSSO: bool,
    });
  }
}

export const UserStore = new UserStoreClass();
